import React from "react"
import { Avatar } from "@planningcenter/components"

const NameBanner = ({ person, info, onClick, linkText }) => (
  <div className="my-4">
    <h2 className="h4 mb-1">{info}</h2>
    <div className="d-f ai-c jc-sb action-drawer">
      <div className="d-f">
        <div className="mr-2">
          <Avatar
            src={`${person.data.attributes.avatar_url}?g=200x200`}
            alt={` Profile image of ${person.data.attributes.name}`}
            size={6}
          />
        </div>
        <div className="d-f fd-c">
          <div>{person.data.attributes.name}</div>
          <div className="fs-13 c-tint2">
            {person.data.attributes.email_address}
          </div>
        </div>
      </div>
      {onClick && linkText && <a onClick={onClick}>{linkText}</a>}
    </div>
  </div>
)

export default NameBanner
